import axios from 'axios';

export default class SupplierService {
    inquiry(data) {
        return axios.post(process.env.VUE_APP_API_ROOT + '/supplier/send-inquiry', data).then((res) => res.data);
    }

    inquirySubmission(data) {
        return axios.put(process.env.VUE_APP_API_ROOT + '/inq/submit', data).then((res) => res.data);
    }

    fetchSupplier(supRefId) {
        if (supRefId) {
            return axios.get(process.env.VUE_APP_API_ROOT + '/product-adhoc/fetch-supplier-by-ref-id/' + supRefId).then((res) => res.data);
        } else {
            return Promise.reject(new Error('fail')).catch((error) => {
                if (process.env.VUE_APP_DEBUG === 'YES') {
                    console.log(error);
                }
            });
        }
    }

    fetchDeliverableCountries(supRefId, defaultCountries) {
        if (supRefId) {
            return axios.get(process.env.VUE_APP_API_ROOT + '/product-adhoc/fetch-supplier-by-ref-id/' + supRefId).then((res) => {
                if (res.data) {
                    var deliverableCountries = res.data['deliverableCountries'];
                    if (deliverableCountries && deliverableCountries.length > 0) {
                        return deliverableCountries;
                    }
                }
                return defaultCountries;
            });
        } else {
            return Promise.reject(new Error('fail')).catch((error) => {
                if (process.env.VUE_APP_DEBUG === 'YES') {
                    console.log(error);
                }
            });
        }
    }

    fetchSupplierOrderProc(supRefId) {
        if (supRefId) {
            return axios.get(process.env.VUE_APP_API_ROOT + '/product-adhoc/fetch-order-processing/' + supRefId).then((res) => res.data);
        } else {
            return Promise.reject(new Error('fail')).catch((error) => {
                if (process.env.VUE_APP_DEBUG === 'YES') {
                    console.log(error);
                }
            });
        }
    }

    searchSuppliers(pageNumber, pageSize) {
        return axios
            .post(process.env.VUE_APP_API_ROOT + '/supplier-adhoc/search-by-params', {
                paginationParam: {
                    pageNumber: pageNumber,
                    pageSize: pageSize,
                },
            })
            .then((res) => res.data);
    }

    performGuidedSearch(catz, srtTitle, pageNumber, pageSize) {
        return axios
            .post(process.env.VUE_APP_API_ROOT + '/supplier-adhoc/search-by-guidance', {
                pageNumber: pageNumber,
                pageSize: pageSize,
                prodClasses: catz,
                sortByTitle: srtTitle,
            })
            .then((res) => res.data);
    }

    performTextSearch(txt, srtTitle, pageNumber, pageSize) {
        return axios
            .post(process.env.VUE_APP_API_ROOT + '/supplier-adhoc/search-by-text', {
                pageNumber: pageNumber,
                pageSize: pageSize,
                txt: txt,
                sortByTitle: srtTitle,
            })
            .then((res) => res.data);
    }

    searchSuppliersByProdCategories(pageNumber, pageSize, categories) {
        let payload = {
            filter: {
                filterParams: [
                    {
                        filterType: 'textArray',
                        filterExpression: 'in',
                        key: 'classification',
                        textArrayValue: { list: categories },
                        order: 0,
                    },
                ],
                logic: 'and',
            },
            paginationParam: {
                pageNumber: pageNumber,
                pageSize: pageSize,
            },
            sortingParams: [
                {
                    key: 'updatedDate',
                    order: 0,
                    sortType: 'desc',
                },
            ],
        };

        return axios.post(process.env.VUE_APP_API_ROOT + '/supplier-adhoc/search-by-params', payload).then((res) => res.data);
    }

    fetchSupplierByCode(code) {
        return axios
            .post(process.env.VUE_APP_API_ROOT + '/supplier/fetch-by-code', {
                code: code,
            })
            .then((res) => res.data);
    }

    fetchCouponInfo(couponCode, supplierRefId) {
        return axios.get(process.env.VUE_APP_API_ROOT + '/coupon-adhoc/retrieve/' + supplierRefId + '/' + couponCode).then((res) => res.data);
    }
}
